module.exports = "<div class=\"jumbotron\" v-bind:class=\"{ 'jumbotron-fluid': fluid }\">\n  <div class=\"container\">\n    <slot></slot>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/jumbotron/jumbotron.html
// module id = 48
// module chunks = 0